import { Component, Input, TemplateRef } from '@angular/core';

@Component({
  selector: 'conn-label-with-tooltip',
  templateUrl: './conn-label-with-tooltip.component.html',
  styleUrls: ['./conn-label-with-tooltip.component.css'],
  standalone: false,
})
export class ConnLabelWithTooltipComponent {
  @Input() labelText: string;
  @Input() tooltipPlacement: string;
  @Input() tooltipText: TemplateRef<unknown>;
  @Input() tooltipOpenDelay: number;
  @Input() tooltipCloseDelay: number;
  @Input() maxTextWrappedWidthInPx = -1;

  /**
   * Splits the given label into two parts: all words except the last (`before`), and the last word (`last`).
   * Useful for highlighting or styling the last word differently in the UI.
   * @returns An object with `before` (all but the last word) and `last` (the last word).
   */
  get labelParts(): { before: string; last: string } {
    const safeLabel = this.labelText || '';
    const words = safeLabel.trim().split(/\s+/).filter(Boolean);
    if (words.length === 0) {
      return { before: '', last: '' };
    }
    return {
      before: words.slice(0, -1).join(' '),
      last: words[words.length - 1],
    };
  }
}
